export default __webpack_public_path__ + "static/why-3-64f709087700102dd431a8eff2ae8708.png";